module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/companies-admin/company-edit/company-edit.component.css
// module id = ./src/app/companies-admin/company-edit/company-edit.component.css
// module chunks = main